<template>
    <div class="create-hpc-btn-container"
         v-show="!hideBtn">
        <!-- 已实名认证 不显示Tooltip 不禁用 -->
        <!-- <Tooltip theme="light"
                 placement="bottom-start"
                 style="vertical-align: middle;cursor: pointer;"
                 :content="$t(noticeShare)"
                 :disabled="noticeShare.length==0">
            <Button type="primary"
                    v-if="hasPermission('CB1709') && !(isDisableShareBtn || isFreezeStatus || isHpcFreezeStatus)"
                    @click="openResPool()"
                    class="btn-res left">
                <i class="icon-plus-o-1"></i>{{$t('开通共享资源池')}}
            </Button>
        </Tooltip> -->
        <Dropdown trigger="click"
                  :transfer="true"
                  placement="bottom-start"
                  @on-click="openResPool"
                  v-if="hasPermission('CB1709')"
                  class="btn-res left">
            <!-- 无权限提示 不显示Tooltip 不禁用 -->
            <Tooltip theme="light"
                     :disabled="noticeShare.length==0"
                     placement="bottom-start"
                     :content="$t(noticeShare)"
                     :transfer="true">
                <Button type="primary"
                        :disabled="isDisableShareBtn"
                        style="height:32px;">
                    <i class="icon-plus-o-1"></i>
                    <span>{{$t('开通共享资源池')}}</span>
                    <Icon type="ios-arrow-down"></Icon>
                </Button>
            </Tooltip>

            <DropdownMenu slot="list">
                <DropdownItem :name="item.id"
                              v-for="item in hpcList"
                              :key="item.id"
                              :disabled='item.accountFrozen || !item.open'
                              :title="item.accountFrozen?'已冻结,无法执行该操作':''"
                              class="create-hpc-btn-container-drop-item">
                    {{$t(item.productName)}}
                </DropdownItem>
                <div v-if="hpcList.length === 0"
                     class="net-no-data">
                    &nbsp;
                    <i class="icon-prompt-1-o"></i>
                    &nbsp;{{$t('暂无数据')}}
                </div>
            </DropdownMenu>
        </Dropdown>

        <Dropdown trigger="click"
                  :transfer="true"
                  placement="bottom-start"
                  @on-click="openResPool"
                  v-if="hasPermission('CB1710') "
                  class="btn-res left">
            <!-- 无权限提示 不显示Tooltip 不禁用 -->
            <Tooltip theme="light"
                     :disabled="noticeDrp.length==0"
                     placement="bottom-start"
                     :content="$t(noticeDrp)"
                     :transfer="true">
                <Button type="primary"
                        :disabled="isDisableDrpBtn || isFreezeStatus || isHpcDrpFreezeStatus"
                        style="height:32px;">
                    <i class="icon-plus-o-1"></i>
                    <span>{{$t('创建专属资源池')}}</span>
                    <Icon type="ios-arrow-down"></Icon>
                </Button>
            </Tooltip>

            <DropdownMenu slot="list">
                <DropdownItem :name="item.id"
                              v-for="item in resList"
                              :key="item.id"
                              class="create-hpc-btn-container-drop-item">
                    {{$t(item.productName)}}
                </DropdownItem>
                <div v-if="resList.length === 0"
                     class="net-no-data">
                    &nbsp;
                    <i class="icon-prompt-1-o"></i>
                    &nbsp;{{$t('暂无数据')}}
                </div>
            </DropdownMenu>
        </Dropdown>
        <Tooltip theme="light"
                 placement="bottom-start"
                 style="vertical-align: middle;cursor: pointer;"
                 :content="$t(packageNotice)"
                 :disabled="packageNotice.length==0">
            <Button type="primary"
                    v-if="hasPermission('CC0502') "
                    :disabled="(discountBuy || isAuthentStatus || isFreezeStatus|| isBizBagFreezeStatus || parentSid != null)"
                    @click="openPackagel()"
                    class="btn-res right">
                <i class="icon-plus-o-1"></i>{{$t('购买套餐包')}}
            </Button>
        </Tooltip>
    </div>
</template>

<script>
import API from '@/service/api.js'
export default {
    name: 'CreateHpcBtn',
    props: {
        productType: {
            type: String,
            default: 'hpc'
        }
    },
    data () {
        return {
            shareHpcCode: 'HPC',
            productListCode: {
                hpc: ['HPC-DRP']
            },
            hideBtn: true,
            hasShareHpc: false,
            resList: [],
            hpcList: [],
            authType: this.$store.state.user.currentUser.info.authType,
            discountBuy: false // 套餐包上下架 false 上架
        }
    },
    created () {
        this.initData()
    },
    computed: {
        isFreezeStatus () {
            // 用户是否冻结
            return this.$store.state.user.currentUser.isFreezeStatus
        },
        isHpcFreezeStatus () {
            // hpc共享是否冻结
            return this.$store.state.user.currentUser.isHpcFreezeStatus
        },
        isHpcSaasFreezeStatus () {
            // hpc-saas共享是否冻结
            return this.$store.state.user.currentUser.isHpcSaasFreezeStatus
        },
        isHpcDrpFreezeStatus () {
            // hpc专属是否冻结
            return this.$store.state.user.currentUser.isHpcDrpFreezeStatus
        },
        isBizBagFreezeStatus () {
            // 套餐包是否冻结
            return this.$store.state.user.currentUser.isBizBagFreezeStatus
        },
        verified () {
            return this.$store.state.user.currentUser.info.authentStatus === 'authSucceed' // 是否实名认证 true 认证
        },
        // 是否实名认证和企业认证
        isAuthentStatus () {
            const userAuth = this.$store.state.user.currentUser.info.authentStatus
            const comAuth = this.$store.state.user.currentOrg.certificationStatus
            const flag = this.authType === 'company' ? comAuth !== 'authSucceed' : userAuth !== 'authSucceed'
            return flag
        },
        authTypeName () {
            return this.authType === 'company' ? '企业' : '实名'
        },
        parentSid () {
            return this.$store.state.user.currentUser.info.parentSid || null
        },
        isDisableCreateBtn () {
            return !this.hasPermission('CB1703') || this.isAuthentStatus || this.parentSid !== null
        },
        isDisableShareBtn () {
            return this.isDisableCreateBtn || this.hpcList.length === 0 || this.hasShareHpc
        },
        isDisableDrpBtn () {
            return this.isDisableCreateBtn || this.resList.length === 0
        },
        notice () {
            let msg = ''
            if (!this.hasPermission('CB1703')) {
                msg = '暂无开通权限'
            } else if (this.isAuthentStatus) {
                return this.$t(`账号未进行${this.authTypeName}认证，无法执行该操作`)
            } else if (this.parentSid !== null) {
                msg = '子用户，无开通服务权限'
            }
            /*
             else if (!this.verified) {
                msg = '账号未进行实名认证，无法执行该操作'
            }
            */

            return msg
        },
        noticeShare () {
            if (this.notice) {
                return this.notice
            } else if (this.isHpcFreezeStatus && this.isHpcSaasFreezeStatus) {
                return '账户已冻结，无法执行该操作'
            } else if (this.hasShareHpc) {
                return '共享资源池已完成开通，暂不支持重复购买'
            } else if (!this.hpcList.length) {
                return '共享资源池暂未上架'
            }
            return ''
        },
        noticeDrp () {
            if (this.notice) {
                return this.notice
            } else if (this.resList.length === 0) {
                return '专属资源池暂未上架'
            } else if (this.isFreezeStatus || this.isHpcDrpFreezeStatus) {
                return '账户已冻结，无法执行该操作'
            }
            return ''
        },
        packageNotice () {
            let msg = ''
            if (!this.hasPermission('CC0502')) {
                msg = '暂无开通权限'
            } else if (this.discountBuy) {
                msg = '套餐包未上架，无法执行该操作'
            } else if (this.isAuthentStatus) {
                msg = `账号未进行${this.authTypeName}认证，无法执行该操作`
            } else if (this.isFreezeStatus || this.isBizBagFreezeStatus) {
                return '账户已冻结，无法执行该操作'
            } else if (this.parentSid !== null) {
                msg = '子用户，无开通服务权限'
            }
            return msg
        }
    },
    methods: {
        noRrepeat (arr) {
            const data = {}
            const newArr = arr.reduce((sum, current) => {
                if (!data[JSON.stringify(current)]) {
                    data[JSON.stringify(current)] = true
                    sum.push(current)
                }
                return sum
            }, [])
            return newArr
        },
        initData () {
            let servicesList = []
            this.axios.get(this.urlFormat(API.GET_CLOUD_MARKET, true)).then(res => {
                if (res && res.length) {
                    res.forEach(item => {
                        Array.isArray(item.services) && (servicesList = [...servicesList, ...item.services])
                    })
                }
                const selectCode = this.productListCode[this.productType]
                // 专属资源List
                this.resList = this.noRrepeat(servicesList.filter(item => selectCode.includes(item.showType)))
            })
            // 套餐包上下架
            if (this.parentSid) {
                this.discountBuy = true
            } else {
                this.axios.get(this.urlFormat(API.GET_BAG_BUY + '?productType=HPC&status=online', false)).then(res => {
                    if (JSON.stringify(res) === '{}') {
                        this.discountBuy = true
                    }
                })
            }
            this.getHpcCluster()
        },
        getHpcCluster () {
            this.hpcList = []
            this.axios.get(this.urlFormat(API.GET_HPC_CLUSTER + '?productType=HPC', false)).then(res => {
                this.hideBtn = false
                if (res.length) {
                    if (!res.find(item => item.open)) { // open: true可以购买 false已购买
                        this.hasShareHpc = true
                    } else {
                        this.hasShareHpc = false
                        this.hpcList = res
                    }
                }
            })
        },
        openResPool (id) {
            const { href } = this.$router.resolve({
                path: `/apply/${id}`
            })
            window.open(href, '_blank')
        },
        openPackagel () {
            const routeData = this.$router.resolve({ path: '/applyPackage' })
            window.open(routeData.href, '_blank')
        }
    }
}
</script>

<style lang="less" scoped>
.create-hpc-btn-container {
    .btn-res {
        &.left {
            margin-right: 6px;
        }
    }
}
</style>

<style lang="less">
.create-hpc-btn-container-drop-item {
    min-width: 143px;
}
</style>
